import * as React from "react";
import type { SVGProps } from "react";
const SvgMicrophone01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.398 11.177A7.68 7.68 0 0 0 12 17.753m0 0a7.68 7.68 0 0 0 7.602-6.576M12 17.753V21.6m.001-19.2A3.29 3.29 0 0 0 8.71 5.691v4.389a3.292 3.292 0 0 0 6.583 0V5.691A3.29 3.29 0 0 0 12 2.4"
    />
  </svg>
);
export default SvgMicrophone01;
